import Vue from 'vue/dist/vue.esm'

document.addEventListener('DOMContentLoaded', () => {
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  var membership = new Vue({
    el: '#donate-one-time-form-container',
    
    data: {
      donation_amount: parseInt(getUrlParameter('one_time_donation_amount')),
      cover_fee: "",
      stripe_fee: 2.9
    },

    methods: {
      setDonation(amount) {
        this.donation_amount = amount;
        document.getElementById("btn100").classList.remove("btn__donate--select--active");
        document.getElementById("btn250").classList.remove("btn__donate--select--active");
        document.getElementById("btn500").classList.remove("btn__donate--select--active");
        document.getElementById("btn1000").classList.remove("btn__donate--select--active");
      }
    }
  })

  let donation_param_amount = getUrlParameter('one_time_donation_amount');

  if(donation_param_amount === "100") {
    document.getElementById("btn100").className += " btn__donate--select--active";
  }

  if(donation_param_amount === "250") {
    document.getElementById("btn250").className += " btn__donate--select--active";
  }

  if(donation_param_amount === "500") {
    document.getElementById("btn500").className += " btn__donate--select--active";
  }

  if(donation_param_amount === "1000") {
    document.getElementById("btn1000").className += " btn__donate--select--active";
  }

  if(donation_param_amount === "other_amount") {
    window.onload = function() {
      var input = document.getElementById("donations_amount").focus();
    }
  }
})
